




































import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

const QuoteTemplateNoteField = mixins(Proxyable);

export default QuoteTemplateNoteField.extend({
  name: 'QuoteTemplateNoteField',

  props: {
    errorMessages: { type: Array, default: () => [] }
  },

  data() {
    return {
      showNote: false
    };
  },
  methods: {
    toggleShowNote() {
      this.showNote = !this.showNote;
    }
  }
});
